import { render, staticRenderFns } from "./PromotionBanner.vue?vue&type=template&id=3b35c6e0&scoped=true&"
import script from "./PromotionBanner.vue?vue&type=script&lang=js&"
export * from "./PromotionBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromotionBanner.vue?vue&type=style&index=0&id=3b35c6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35c6e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiLazyVideo: require('/app/components/UI/UiLazyVideo.vue').default})
